import { parseChildren, allHtmlParsers } from '@utils/ast';
import { parseTextComponentHtmlNode } from './component.text.html.js';

const parseGlossaryWord = (node, context) => {
  const id = node.getAttribute("id");
  const children = parseChildren(node, allHtmlParsers, context.depth + 1);
  if (!id) {
    return {
      nodeType: "html",
      tagName: "span",
      attributes: {
        "data-glossary-word": "missing id"
      },
      children
    };
  }
  return {
    nodeType: "text-component.glossary-word",
    meta: {
      glossaryWordId: id
    },
    children
  };
};
const parseSpan = (node, context) => {
  if (!node.classList.contains("ordforklaring")) {
    return parseTextComponentHtmlNode(node, context);
  }
  const id = node.getAttribute("data-opslag");
  const children = parseChildren(node, allHtmlParsers, context.depth + 1);
  if (!id) {
    return {
      nodeType: "html",
      tagName: "span",
      attributes: {
        "data-glossary-word": "missing id"
      },
      children
    };
  }
  return {
    nodeType: "text-component.glossary-word",
    meta: {
      glossaryWordId: id
    },
    children
  };
};
const textComponentGlossaryWordParsers = {
  glossaryword: parseGlossaryWord,
  span: parseSpan
};

export { textComponentGlossaryWordParsers };
//# sourceMappingURL=component.text.glossary-words.js.map
